import { useNavigate } from "react-router-dom"

import { getBackButtonText } from "./helpers"
import styles from "./styles.module.scss"

import { HeaderRoot, HeaderMenu } from "components/Header"
import { StepsCounter } from "ui-kit/components-branded/index"
import { isAuthPage, isPsyAccountPage } from "app/AppRouter/utils"
import { useFrom, useFromLink } from "utils/hooks"
import { BackButton, GoToAuth, HeaderLogo } from "components/Header/components"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"

interface PageHeaderProps {
    openLogo?: {
        newTab?: boolean
        url?: string
    }
    showBackButton?: boolean
    step?: {
        current: number
        total: number
        previous: () => void
        buttonText?: string
    }
    showRight?: "menu" | "discount"
}

export function PageHeader({ openLogo, showBackButton, step }: PageHeaderProps) {
    const [{ isVerified }] = useClientContext()
    const navigate = useNavigate()
    const from = useFrom()
    const fromLink = useFromLink()
    function clickButton() {
        if (fromLink) {
            navigate(fromLink)
        }
    }

    const backButtonLabel = getBackButtonText(from)

    return (
        <>
            <HeaderRoot>
                <div className={styles.left}>
                    {showBackButton && fromLink && (
                        <BackButton label={backButtonLabel} onClick={clickButton} />
                    )}
                    {step && (
                        <StepsCounter
                            current={step.current + 1}
                            maxCount={step.total}
                            onBackClick={step.previous}
                        >
                            <StepsCounter.BackClickHandler className={styles.stepsCounter}>
                                <StepsCounter.BackIcon />
                                <StepsCounter.Counter text={step.buttonText} />
                            </StepsCounter.BackClickHandler>
                        </StepsCounter>
                    )}
                </div>
                <HeaderLogo target={openLogo?.newTab ? "_blank" : undefined} url={openLogo?.url}>
                    alter
                </HeaderLogo>
                {!isVerified && !isAuthPage() && !isPsyAccountPage() && <GoToAuth />}
                {isVerified && <HeaderMenu />}
            </HeaderRoot>
        </>
    )
}
